import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import { Navigation, Pagination } from 'swiper/modules';

export default class Companies {
    constructor() {

        this.section = document.querySelector('.component-companies');
        this.slider = this.section.querySelector('.swiper');
        // this.navigationPrev = this.section.querySelector('.slider-button-prev');
        // this.navigationNext = this.section.querySelector('.slider-button-next');
        // this.pagination = this.section.querySelector('.swiper-pagination-nav');

        this.ready();

    }

    ready() {

        const swiper = new Swiper(this.slider, {
            // modules: [Navigation, Pagination],
            grabCursor: true,
            allowTouchMove: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                    slidesOffsetBefore: 28,
                    slidesOffsetAfter: 28,
                },
                1024: {
                    slidesPerView: 6,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    // navigation: {
                    //     nextEl: this.navigationNext,
                    //     prevEl: this.navigationPrev,
                    // },
                    // pagination: {
                    //     el: this.pagination,
                    //     clickable: true
                    // },
                }
            }
        });
    }

}

if (document.querySelector('.component-companies')) {
    new Companies();
}